import { ProductsSelectionForm } from '@shared/components/ProductsSelectionForm';
import { useSettlementPricesSettings } from '../../settlement-prices/SettlementPricesContext';

export const SettlementsProductsSettingsForm = () => {
  const { addColumn, selectedColIds, toggleColumn, selectedUserProducts } = useSettlementPricesSettings();
  const SETTLEMENTS_PRODUCTS_LIMIT = 50;

  return (
    <ProductsSelectionForm
      selectedColIds={selectedColIds}
      selectedUserProducts={selectedUserProducts}
      maxProductsLimit={SETTLEMENTS_PRODUCTS_LIMIT}
      addColumn={addColumn}
      toggleColumn={toggleColumn}
    />
  );
};
